module.exports = __webpack_public_path__ + "static/media/exames_02.46aaaf13.jpg";